module.exports = __webpack_public_path__ + "img/echartimg1.6f5f661a.png";